<template>
  <div
    class="content panel"
    :class="{ dark: dark === 'dark', light: dark === 'light' }"
  >
    <b-row>
      <b-col
        lg="6"
        md="12"
        cols="12"
        :order-lg="right(attrs.enable_right)"
        :order-md="right(attrs.enable_right)"
        order="1"
        :class="{ darkCol: dark === 'dark' }"
      >
        <Mod :picked="mod" :type="type" />
      </b-col>
      <b-col
        lg="6"
        md="12"
        cols="12"
        :order-lg="left(attrs.enable_right)"
        :order-md="left(attrs.enable_right)"
        order="2"
        :class="{ darkCol: dark === 'dark' }"
      >
        <b-row style="height: 100%;">
          <b-col style="margin: auto; padding: ;">
            <div>
              <div class="textBox">
                <h2
                  :class="{ dark: dark === 'dark', light: dark === 'light' }"
                  class="title"
                >
                  {{ attrs.title }}
                </h2>
                <p
                  :class="{ dark: dark === 'dark', light: dark === 'light' }"
                  class="text"
                  v-html="attrs.text"
                ></p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Mod from "@/components/3d-modal.vue";
export default {
  props: ["attrs", "dark"],
  components: {
    Mod
  },
  methods: {
    left(input) {
      var align = "";
      if (input === true) {
        align = 1;
      } else {
        align = 2;
      }
      return align;
    },
    right(input) {
      var align = "";
      if (input === true) {
        align = 2;
      } else {
        align = 1;
      }
      return align;
    }
  },
  computed: {
        mod(modal) {
      if (this.attrs.modal === "torpedo-2.fbx") {
        modal = "/torpedo/torpedo-2.fbx";
      } 
      return modal;
    },
    type(type) {
      if (this.attrs.modal.includes(".fbx")) {
        type = "fbx";
      } else {
        type = "gltf";
      }
      return type;
    }
  }
};
</script>

<style scoped>
h2 {
  padding: 0 0 50px;
  text-align: center;
}
</style>
